import * as Joi from 'joi';
import {UpdatePasswordForm} from '../../../models';
import {validatePasswordStrength} from './resetPassword';

const updatePasswordSchema = Joi.object<UpdatePasswordForm>({
  oldPassword: Joi.string().required().messages({
    'string.empty': 'Old password is not allowed to be empty',
    'any.required': 'Old password is required',
  }), newPassword: Joi.string()
  .custom(validatePasswordStrength, 'Validate password strength')
  .min(12)
  .required()
  .messages({
    'string.min': 'New Password too short!',
    'string.max': 'New Password too long!',
    'string.pattern.name': 'New Password too weak!',
    'string.empty': 'New password is not allowed to be empty',
    'any.required': 'New password is required',
  }), confirmNewPassword: Joi.any()
  .equal(Joi.ref('newPassword'))
  .required()
  .messages({
    'any.required': 'Confirm New Password is required',
  })
  .options({messages: {'any.only': 'Password do not match'}}),
});

export default updatePasswordSchema;
